module.exports = "/static/assets/d12a999338123fc4e1e65502f703efbe.png";